import { useState, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useClaimBill } from '../billing/useClaimBill.js';
import { useBusinessNumber } from '../../../../shared/hooks/useBusinessNumber.js';

export function TaxValidationPage(): ReactNode {
  const { t } = useTranslation();

  const { money } = useBusinessNumber();
  const { claimId } = useParams<{ claimId: string }>();
  const { token } = useAuth();
  const { bill, error: claimError } = useClaimBill(`/v1/approval/claim/${claimId}`);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [form, setForm] = useState({ cgstPct: '', sgstPct: '', igstPct: '', cessPct: '', cgstAmount: '', sgstAmount: '', igstAmount: '', cessAmount: '', claimedTaxTotal: '', gstRegistration: '', hsnSacCode: '' });

  const handleValidate = async () => {
    try {
      const r = await apiRequest<any>('/v1/approval/tax-validation/', {
        token, method: 'POST',
        body: { claimId, cgstPct: Number(form.cgstPct), sgstPct: Number(form.sgstPct), igstPct: Number(form.igstPct), cessPct: Number(form.cessPct), cgstAmount: Number(form.cgstAmount), sgstAmount: Number(form.sgstAmount), igstAmount: Number(form.igstAmount), cessAmount: Number(form.cessAmount), claimedTaxTotal: Number(form.claimedTaxTotal), gstRegistration: form.gstRegistration, hsnSacCode: form.hsnSacCode },
      });
      setResult(r);
    } catch (e) { setError((e as Error).message); }
  };

  const fields = [
    { k: 'cgstPct', l: t('fa.tax.cgstPct'), t: 'number' }, { k: 'sgstPct', l: t('fa.tax.sgstPct'), t: 'number' },
    { k: 'igstPct', l: t('fa.tax.igstPct'), t: 'number' }, { k: 'cessPct', l: t('fa.tax.cessPct'), t: 'number' },
    { k: 'cgstAmount', l: t('fa.tax.cgstAmount'), t: 'number' }, { k: 'sgstAmount', l: t('fa.tax.sgstAmount'), t: 'number' },
    { k: 'igstAmount', l: t('fa.tax.igstAmount'), t: 'number' }, { k: 'cessAmount', l: t('fa.tax.cessAmount'), t: 'number' },
    { k: 'claimedTaxTotal', l: t('fa.tax.claimedTaxTotal'), t: 'number' },
    { k: 'gstRegistration', l: t('fa.tax.gstRegistration') }, { k: 'hsnSacCode', l: t('fa.tax.hsnSacCode') },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h1>{t('fa.tax.title', { bill })}</h1>
      {(error ?? claimError) && <p style={{ color: 'red' }}>{error ?? claimError}</p>}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, maxWidth: 700, marginBottom: 16 }}>
        {fields.map(f => (
          <label key={f.k}>{f.l}<br /><input type={f.t ?? 'text'} value={(form as any)[f.k]} onChange={e => setForm({ ...form, [f.k]: e.target.value })} style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid var(--color-border-default)' }} /></label>
        ))}
      </div>
      <button onClick={handleValidate} style={{ padding: '8px 24px', background: 'var(--color-text-link)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 6, cursor: 'pointer' }}>{t('fa.tax.validateBtn')}</button>
      {result && (
        <div style={{ marginTop: 16, padding: 16, border: '1px solid var(--color-border-default)', borderRadius: 8 }}>
          <strong>{t('fa.tax.result')}</strong> <span style={{ color: result.validationResult === 'PASS' ? 'var(--color-success)' : 'var(--color-danger)' }}>{result.validationResult}</span>
          <span>{t('fa.tax.calcVariance', { calc: money(Number(result.calculatedTaxTotal)), variance: money(Number(result.varianceAmount)) })}</span>
        </div>
      )}
    </div>
  );
}
